import { DocumentTemplate } from '../../../__generated__/graphql';

export const mapDocumentTemplate = (documentTemplate: DocumentTemplate) => {
  return {
    label: documentTemplate.Name,
    value: documentTemplate.Id,
  };
};
